// removed by extract-text-webpack-plugin
module.exports = {"root":"StoryCard__root--3D7So","featured":"StoryCard__featured--2LRFT","factsMatter":"StoryCard__factsMatter--1GsxW","slideIn":"StoryCard__slideIn--r9piN","bounce":"StoryCard__bounce--_IQ4j","hide":"StoryCard__hide--3MQDh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/StoryCard/StoryCard.css
// module id = ./src/components/Library/StoryCard/StoryCard.css
// module chunks = 2